import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type {
    ActivationAlertsContractSeoAlertType,
    ActivationAlertsContractTrafficType,
} from "@similarweb/pro-api-client";

export const TRAFFIC_TYPES: ActivationAlertsContractTrafficType[] = ["Organic", "Paid"];
export const ALERT_TYPES: ActivationAlertsContractSeoAlertType[] = ["NewKeywords", "NewPages"];

interface ISeoAlertsFilterState {
    searchValue: string;
    selectedAlertType: ActivationAlertsContractSeoAlertType | null;
    selectedTrafficType: ActivationAlertsContractTrafficType | null;
}

interface ISeoAlertsFilterStore extends ISeoAlertsFilterState {
    reset: () => void;
    setSearchValue: (value: string) => void;
    setSelectedAlertType: (type: ActivationAlertsContractSeoAlertType | null) => void;
    setSelectedTrafficType: (type: ActivationAlertsContractTrafficType | null) => void;
}

const initialState: ISeoAlertsFilterState = {
    searchValue: "",
    selectedAlertType: null,
    selectedTrafficType: null,
};

export const useSeoAlertsFilterStore = create<ISeoAlertsFilterStore>()(
    devtools(
        (set) => ({
            ...initialState,
            reset: () => set(() => initialState),
            setSearchValue: (value) => set({ searchValue: value }),
            setSelectedAlertType: (type) => set({ selectedAlertType: type }),
            setSelectedTrafficType: (type) => set({ selectedTrafficType: type }),
        }),
        { name: "SeoAlertsFilterStore" },
    ),
);
